module.exports = __webpack_public_path__ + "modelace-postavy-liposukce_16_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/modelace-postavy-liposukce_16_before.jpg
// module id = 1096
// module chunks = 0